import { Inject, Injectable } from '@angular/core';
import { AutomationReplacementChipsDataService, PagedResponse } from '../common/components';
import { CRMCustomObjectTypeApiService, FieldSchemaInterface, CustomObjectTypeInterface } from '@vendasta/crm';
import { AUTOMATION_NAMESPACE_INJECTION_TOKEN$ } from '@galaxy/automata/shared';
import { map, Observable, of, take } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CrmCustomObjectTypeSelectorService implements AutomationReplacementChipsDataService<FieldSchemaInterface> {
  supportsSearching = true;

  constructor(
    private readonly crmCustomObjectTypeApiService: CRMCustomObjectTypeApiService,
    @Inject(AUTOMATION_NAMESPACE_INJECTION_TOKEN$) public readonly namespace$: Observable<string>,
  ) {}

  doLookup(): Observable<PagedResponse<CustomObjectTypeInterface>> {
    return this.namespace$.pipe(
      switchMap((namespace) =>
        this.crmCustomObjectTypeApiService.listCustomObjectTypes({
          namespace: namespace,
        }),
      ),
      take(1),
      map((resp) => {
        return {
          results: resp?.customObjectTypes,
          hasMore: false,
          nextCursor: '',
        };
      }),
    );
  }

  convertDataToDisplay(c: CustomObjectTypeInterface): Observable<string> {
    return of(c?.pluralObjectName || '');
  }

  convertDataToFormValue(c: CustomObjectTypeInterface): any {
    return c.customObjectTypeId;
  }

  getMulti(customObjectTypeIds: string[]): Observable<CustomObjectTypeInterface[]> {
    return this.namespace$.pipe(
      switchMap((namespace) =>
        this.crmCustomObjectTypeApiService.getMultiCustomObjectType({
          namespace: namespace,
          customObjectTypeIds: customObjectTypeIds,
        }),
      ),
      map((resp) => resp?.customObjectTypes || []),
    );
  }
}
